exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.load-extension_code_18JAZ,\r\n.load-extension_unsandboxed-container_3wUNS,\r\n.load-extension_unsandboxed-warning_3AXrs,\r\n.load-extension_sandboxed_2q4uS {\r\n    margin: 8px 0;\r\n}\r\n\r\n.load-extension_unsandboxed-container_3wUNS {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.load-extension_unsandboxed-checkbox_3F7r1 {\r\n    margin-right: 8px;\r\n}\r\n\r\n.load-extension_unsandboxed-warning_3AXrs {\r\n    padding: 0.5rem;\r\n    border-radius: 0.25rem;\r\n    background-color: rgba(255, 81, 81, 0.25);\r\n    border: 1px solid red;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"code": "load-extension_code_18JAZ",
	"unsandboxed-container": "load-extension_unsandboxed-container_3wUNS",
	"unsandboxedContainer": "load-extension_unsandboxed-container_3wUNS",
	"unsandboxed-warning": "load-extension_unsandboxed-warning_3AXrs",
	"unsandboxedWarning": "load-extension_unsandboxed-warning_3AXrs",
	"sandboxed": "load-extension_sandboxed_2q4uS",
	"unsandboxed-checkbox": "load-extension_unsandboxed-checkbox_3F7r1",
	"unsandboxedCheckbox": "load-extension_unsandboxed-checkbox_3F7r1"
};